export default {
  "b2b.renderers.aktivni.vyluka": "Výluka",
  "b2b.renderers.ano-ne.ano": "ANO",
  "b2b.renderers.ano-ne.ne": "NE",
  "b2b.renderers.poznamka-modi.label": "Upravena poznámka",
  "b2b.renderers.poznamka-modi.zakaznik": "Zákazník",
  "b2b.renderers.poznamka-modi.spravce": "Správce",
  "b2b.renderers.poznamka-modi.strojvedouci": "Strojvedoucí"
};
